module.exports = __webpack_public_path__ + "img/zeilwagenrijden--white.098dc035.svg";